<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" class="control e-control">
        <ejs-progressbar v-bind="syncfusionConfig" :ref="config.ref || config.id" :value="localValue" :type="config.pType" :animation="config.animation || animation">
            <e-progressbar-annotations v-if="config.showValueLabel">
                <e-progressbar-annotation
                    :content="labelContent"
                ></e-progressbar-annotation>
            </e-progressbar-annotations>
        </ejs-progressbar>
    </div>
</template>

<script>
import {
    ProgressBarAnnotationsDirective, ProgressBarAnnotationDirective
} from "@syncfusion/ej2-vue-progressbar/src/progressbar/annotations.directive";
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlMixins } from "./controlMixins.js";

let editorSettings = {
    pType: {
        type: 'dropdown',
        label: 'Type',
        items: [
            {
                text: 'Linear',
                value: 'Linear',
            },
            {
                text: 'Circular',
                value: 'Circular',
            },
        ],
        fields: {
            text: 'text',
            value: 'value'
        }
    },
    height: {
        type: 'number',
        label: 'Height',
    },
    trackThickness: {
        type: 'number',
        label: 'Track Thickness',
        default: 24,
        helpText: 'Determines the thickness of the incomplete (total) progress indicator.'
    },
    progressThickness: {
        type: 'number',
        label: 'Progress Thickness',
        default: 24,
        helpText: 'Determines the thickness of the complete progress indicator.'
    },
    showValueLabel: {
        id: 'showValueLabel',
        type: 'boolean',
        label: 'Show Value Label',
        default: true
    },
    fontColor: {
        id: 'fontColor',
        type: 'color',
        label: 'Value Label Color',
        default: '#0079d6',
        helpText: 'Specifies the color of the label text.'
    },
    fontSize: {
        id: 'fontSize',
        type: 'string',
        label: 'Font Size',
        default: '20px',
        message: 'eg: 20px, or 2em'
    },
    fontFamily: {
        id: 'fontFamily',
        type: 'text',
        label: 'Font Family',
        default: '',
        helpText: 'Specify the font family for the label.'
    },
    fontWeight: {
        id: 'fontWeight',
        type: 'dropdown',
        label: 'Font Weight',
        items: [
            'bold',
            'normal'
        ],
        default: 'bold',
        helpText: 'Specify the font weight for the label.'
    }
};

export const progressComponent = {
    editorSettings: editorSettings,
    mixins: [controlMixins],
    data() {
        return {
            animation: {
                enable: true,
                duration: 800,
                delay: 0
            }
        };
    },
    computed: {
        labelContent() {
            let color = this.config.fontColor || '#0378d5';
            if (!this.config.fontColor) color = '#4596d7';
            let fontSize = this.config.fontSize || '20px';
            let fontFamily = this.config.fontFamily || false;
            let fontWeight = this.config.fontWeight || 'bold';
            let value = this.localValue;
            return '<div id="' + this.dataTestId + '_label" style="'
                + 'font-size:' + fontSize
                + '; font-weight:' + fontWeight
                + '; color:' + color
                + (fontFamily ? '; font-family:' + fontFamily : '')
                + ';">'
                // TODO figure out a better way to fix linear label
                + (this.config.pType === 'Linear' ? '<span style="display:none;"></span>' + value + '%' : '<span>0%</span>')
                + '</div>';
        },
        localValue() {
            let tmpValue = this.value;
            if (tmpValue >= 100) tmpValue = 100;
            return tmpValue;
        }
    },
    components: {
        "ejs-progressbar": defineAsyncComponent(() => import('@common/syncfusion/progressBar')),
        "e-progressbar-annotations": ProgressBarAnnotationsDirective,
        "e-progressbar-annotation": ProgressBarAnnotationDirective
    }
};

export default progressComponent;
</script>
